import jwt_decode from "jwt-decode";
import PubSub from "pubsub-js";
import { getCachedCharacterEntity } from "../entities/CharacterEntityCache";

const clientId =
  window.location.host.startsWith("localhost") || window.location.host.startsWith("exceldevstc")
    ? window.location.host.startsWith("localhost")
      ? "5f5c93801b9c4b75bcbfabdbdfbbec71" /* Dev */
      : "2d48b53ddc264ce99f5be15a57ecdd77" /* Test */
    : "9be757ead13e4e809a1569043292117a"; /* Prod */

const tokenEndpoint = "https://login.eveonline.com/v2/oauth/token";

export interface Token {
  exp: string;
  name: string;
  sub: string;
}
export interface TokenResponse {
  token: string;
  success: boolean;
}

export async function fetchCharacterTokenFromID(id: number) {
  const falseResponse = { token: "", success: false };
  const token = window.localStorage.getItem("accesstoken-" + id);
  if (!token) return falseResponse;
  return await checkToken(token);
}

export const fetchAllCharacters = () => {
  return getCharListArray();
};

export async function fetchFirstCharacterID() {
  const charList = getCharListArray();
  if (!charList.length) return 1;
  const firstChar = charList[0];
  const token = await fetchCharacterTokenFromID(firstChar);
  if (firstChar > 1 && token.success) return firstChar;
  else return 1;
}

async function checkToken(token: string) {
  const character = jwt_decode<Token>(token);
  const id = parseInt(character.sub.split(":")[2]);
  const timeNow = new Date().getTime() / 1000;
  const timeExpiry = parseInt(character.exp);
  const refreshTokenValue = window.localStorage.getItem("refreshtoken-" + id);

  if (id > 1 && refreshTokenValue) {
    if (timeNow + 90 >= timeExpiry) {
      const newToken = await refreshToken(refreshTokenValue, id);
      if (newToken !== false) return { success: true, token: newToken };
      else {
        const characterName = await getCachedCharacterEntity(id);
        PubSub.publish("ERROR", "Unable to refresh token for character: " + characterName?.props.name + " " + id);
        setInvalid(token);
        return { success: false, token: token };
      }
    } else {
      return { success: true, token: token };
    }
  } else {
    PubSub.publish("ERROR", "Missing refresh token for character: " + id);
    setInvalid(token);
    return { success: false, token: token };
  }
}

const setInvalid = (token: string) => {
  const invalidVar = window.sessionStorage.getItem("invalidToken");
  if (invalidVar == null) window.sessionStorage.setItem("invalidToken", token);
  else {
    const combinedInvalidTokens = invalidVar + "," + token;
    window.sessionStorage.setItem("invalidToken", combinedInvalidTokens);
  }
};
export const readInvalid = () => {
  const invalidVar = window.sessionStorage.getItem("invalidToken");
  if (invalidVar !== null) {
    return invalidVar.split(",");
  } else return [];
};

async function refreshToken(token: string, id: number) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  const urlencoded = new URLSearchParams({
    client_id: clientId,
    refresh_token: token,
    grant_type: "refresh_token",
  } as any);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
  };
  return fetch(tokenEndpoint, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.access_token && result.refresh_token) {
        window.localStorage.setItem("accesstoken-" + id, result.access_token);
        window.localStorage.setItem("refreshtoken-" + id, result.refresh_token);
        return result.access_token;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
}

const getCharListArray = () => {
  const list = window.localStorage.getItem("characterList");
  if (!list) {
    console.log("Search didn't find a characterList");
    return [];
  }
  const split = list.split(",");
  const clean = split.map((item) => {
    return parseInt(item);
  });
  return clean;
};
